import { toFetchFailedError, toInvalidIdError, toObjectNotFoundError } from '../../Errors';
import { batchScheduler } from 'batch-promise';
import indexBy from '../../lib/indexBy';
export const resolveBatchFetchedReferences = ({
  debouncePeriod,
  fetchByIds,
  isIdValid,
  maxBatchSize
}) => {
  const {
    queue
  } = batchScheduler().read().identity(id => id).partition(() => 'rrl').execute(calls => fetchByIds(Object.keys(calls)).then(indexBy(result => result.id)).catch(err => {
    throw toFetchFailedError(err);
  })).extract(({
    response,
    identity
  }) => {
    if (!response[identity]) {
      throw toObjectNotFoundError(identity);
    }
    return response[identity];
  }).chunkSize(maxBatchSize).debounce(debouncePeriod);
  return id => {
    if (!isIdValid(id)) {
      return Promise.reject(toInvalidIdError(id));
    }
    return queue(id);
  };
};